<template>
  <div>
    <dx-fieldset-header :text="$t('container_page.status_history')" />
    <dx-data-grid
      v-if="statusHistory"
      ref="statusHistoryGrid"
      class="status-history-grid"
      :data-source="statusHistory"
      :show-column-headers="false"
    >
      <dx-column
        data-field="date"
        :allow-search="false"
        data-type="date"
        :width="100"
      />
      <dx-column
        :allow-search="false"
        cell-template="status-cell-template"
      />
      <template #status-cell-template="{ data }">
        <div>
          <div class="mb-2">
            {{ data.data.status.name }}
          </div>
          <div
            v-if="data.data.status.name !== data.data.status_desc"
            class="mb-2"
          >
            {{ data.data.status_desc }}
          </div>
          {{ data.data.document }}
        </div>
      </template>
    </dx-data-grid>
  </div>
</template>

<script>
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import DxFieldsetHeader from '@/components/common/DxFieldsetHeader';
import createCustomStore from '@/utils/create-custom-store';

export default {
  name: 'StatusHistory',
  components: {
    DxFieldsetHeader,
    DxDataGrid,
    DxColumn,
  },
  props: {
    containerId: [Number, String],
    freightOrderId: [Number, String],
  },
  data: vm => ({
    statusHistory: createCustomStore(`/tracking/api/freight_orders/${vm.freightOrderId}/containers/${vm.containerId}/tracking/`),
  }),
  // created() {
  //   this.getStatusHistory();
  // },
  // methods: {
  //   async getStatusHistory() {
  //     this.statusHistory = await this.$http.get(
  //       `/tracking/api/freight_orders/${this.freightOrderId}/containers/${this.containerId}/tracking/`,
  //     );
  //   },
  // },
};
</script>

<style>
.status-history-grid td {
  vertical-align: top !important;
}
</style>
